<template>
    <div class="toast-stack">
      <NotificationToast
        v-for="(toast, i) in toasts"
        :key="toast.notification_id || i"
        :notification="toast"
        :timeout="toast.timeout || 5000"
        @clicked="handleClick"
        @closed="remove(i)"
      />
    </div>
  </template>
  
  <script>
  import NotificationToast from './NotificationToast.vue';
  
  export default {
    name: 'NotificationToastStack',
    components: { NotificationToast },
    props: {
      toasts: {
        type: Array,
        required: true,
      },
    },
    methods: {
      handleClick(notification) {
        this.$emit('clicked', notification);
      },
      remove(index) {
        this.$emit('remove', index);
      },
    },
  };
  </script>
  
  <style scoped>
  .toast-stack {
    position: fixed;
    top: 80px;
    right: 20px;
    z-index: 3000;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  </style>
  